export const REQUIRED = 'Field is required';
export const LENGTH = 'This field needs to have a mininum length';
export const MATCH = "The fields don't match";
export const EMAIL = 'Email format is invalid';
export const INVALID_URLS = 'Invalid list of urls';
export const STRENGTH = 'Value not strong enough';
export const DOMAIN = 'This domain is not valid';
